import { useState } from 'react';
import { DataGrid } from '../../components/grid/DataGrid';
import { SchedaRapportino } from './SchedaRapportino';

const INTESTAZIONI: Record<string, string> = {
  DataLavoro: 'Giornata',
  OreTotali: 'Ore',
  RigheMateriale: 'Materiale',
  DaCodificare: 'Da codificare',
  SincronizzatoIl: 'Arrivato il',
};

const COLONNE = [
  'DataLavoro',
  'Operaio',
  'Stato',
  'Commesse',
  'OreTotali',
  'RigheMateriale',
  'DaCodificare',
  'SincronizzatoIl',
];

export function ElencoRapportini() {
  const [aperto, setAperto] = useState<string | null>(null);
  const [versione, setVersione] = useState(0);

  return (
    <section className="pagina con-scheda">
      <div className="colonna-principale">
        <header className="testata-pagina">
          <div>
            <h1>Rapportini</h1>
            <p>
              I rapportini arrivati dai telefoni. Apri una riga per vedere le ore commessa
              per commessa e approvarle: l'approvazione è il momento in cui quelle ore
              diventano un costo di commessa, perché il consuntivo conta solo i rapportini
              approvati. Respingere richiede un motivo — l'operaio lo legge sul telefono, e
              non ha nessuno a cui chiedere spiegazioni.
            </p>
            <p className="nota">
              L'elenco apre sui rapportini <strong>inviati</strong>, cioè su quelli che
              aspettano una decisione: uno lasciato lì è lavoro fatto che non compare in
              nessun consuntivo. Il filtro si vede fra i chip e si toglie con un clic per
              rivedere lo storico.
            </p>
          </div>
        </header>

        <DataGrid
          nomeGriglia="rapportini"
          versione={versione}
          colonneVisibili={COLONNE}
          intestazioni={INTESTAZIONI}
          idSelezionato={aperto}
          onRigaSelezionata={(riga) => {
            const id = riga['Id'];
            if (typeof id === 'string') setAperto(id);
          }}
        />
      </div>

      {aperto && (
        <SchedaRapportino
          rapportinoId={aperto}
          onChiudi={() => setAperto(null)}
          onCambiato={() => setVersione((v) => v + 1)}
        />
      )}
    </section>
  );
}
